function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M273.1,75.9V43.8h8.7v25.1h12.4v7H273.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M301.5,75.9V43.8h8.7v32.1H301.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M337.5,43.8h9.7l-10.5,32.1h-10.2L316,43.8h9.8l4.4,16.3c0.9,3.6,1.4,6.1,1.5,7.6c0.1-1,0.3-2.3,0.6-3.8 c0.3-1.5,0.6-2.7,0.8-3.6L337.5,43.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M372,75.9h-19.1V43.8H372v7h-10.4v5.1h9.6v7h-9.6v6.1H372V75.9z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M26.3,69.8c1.2,0,2.6-0.3,4.2-0.8v5c-1.7,0.7-3.7,1.1-6.2,1.1c-2.7,0-4.6-0.7-5.9-2c-1.2-1.4-1.8-3.4-1.8-6.1V55.2h-3.2 v-2.8l3.7-2.2l1.9-5.2h4.3v5.2h6.9v5h-6.9v11.8c0,1,0.3,1.7,0.8,2.1C24.7,69.6,25.4,69.8,26.3,69.8z"
}), React.createElement("path", {
  d: "M51.5,49.7c0.9,0,1.7,0.1,2.3,0.2l-0.5,6.3c-0.5-0.1-1.2-0.2-2-0.2c-2.1,0-3.8,0.5-5,1.6c-1.2,1.1-1.8,2.6-1.8,4.6v12.5 h-6.7V50.2h5.1l1,4.1h0.3c0.8-1.4,1.8-2.5,3.1-3.3C48.5,50.1,49.9,49.7,51.5,49.7z"
}), React.createElement("path", {
  d: "M76,74.7l-1.3-3.3h-0.2c-1.1,1.4-2.3,2.4-3.5,3c-1.2,0.5-2.7,0.8-4.7,0.8c-2.4,0-4.2-0.7-5.6-2c-1.4-1.3-2-3.3-2-5.8 c0-2.6,0.9-4.5,2.7-5.8c1.8-1.2,4.6-1.9,8.2-2.1l4.3-0.1v-1.1c0-2.5-1.3-3.7-3.8-3.7c-2,0-4.3,0.6-6.9,1.8l-2.2-4.5 c2.8-1.5,6-2.2,9.4-2.2c3.3,0,5.8,0.7,7.6,2.2s2.6,3.6,2.6,6.5v16.4H76z M74.1,63.4l-2.6,0.1c-1.9,0.1-3.4,0.4-4.3,1.1 c-1,0.6-1.4,1.6-1.4,2.9c0,1.9,1.1,2.8,3.3,2.8c1.6,0,2.8-0.4,3.7-1.3c0.9-0.9,1.4-2.1,1.4-3.6V63.4z"
}), React.createElement("path", {
  d: "M112.5,74.7h-6.7V60.4c0-1.8-0.3-3.1-0.9-4c-0.6-0.9-1.6-1.3-3-1.3c-1.9,0-3.2,0.6-4.1,1.9c-0.8,1.3-1.3,3.3-1.3,6.2v11.6 h-6.7V50.2H95l0.9,3.1h0.4c0.7-1.2,1.8-2.1,3.1-2.7c1.3-0.6,2.8-0.9,4.5-0.9c2.9,0,5,0.8,6.5,2.3c1.5,1.5,2.2,3.8,2.2,6.7V74.7z"
}), React.createElement("path", {
  d: "M138.8,67.4c0,2.5-0.9,4.4-2.6,5.8c-1.8,1.3-4.4,2-7.9,2c-1.8,0-3.3-0.1-4.6-0.4c-1.3-0.2-2.4-0.6-3.5-1.1v-5.5 c1.2,0.6,2.6,1.1,4.2,1.5s2.9,0.6,4.1,0.6c2.4,0,3.6-0.7,3.6-2.1c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.9-0.7-1.7-1.1 c-0.8-0.4-1.8-0.9-3.2-1.5c-1.9-0.8-3.3-1.5-4.2-2.2c-0.9-0.7-1.5-1.4-1.9-2.3c-0.4-0.9-0.6-1.9-0.6-3.2c0-2.2,0.8-3.9,2.5-5.1 c1.7-1.2,4.1-1.8,7.2-1.8c3,0,5.8,0.6,8.6,1.9l-2,4.8c-1.2-0.5-2.4-1-3.4-1.3c-1.1-0.3-2.2-0.5-3.3-0.5c-2,0-3,0.5-3,1.6 c0,0.6,0.3,1.1,1,1.6c0.6,0.4,2,1.1,4.2,2c1.9,0.8,3.3,1.5,4.2,2.2c0.9,0.7,1.6,1.4,2,2.3C138.6,65.2,138.8,66.2,138.8,67.4z"
}), React.createElement("path", {
  d: "M168.3,74.7h-6.7V60.4c0-1.8-0.3-3.1-0.9-4c-0.6-0.9-1.5-1.3-2.8-1.3c-1.7,0-3,0.6-3.7,1.9c-0.8,1.3-1.2,3.3-1.2,6.2v11.6 h-6.7V50.2h5.1l0.9,3.1h0.4c0.7-1.1,1.6-2,2.9-2.6c1.2-0.6,2.7-1,4.3-1c3.7,0,6.2,1.2,7.5,3.6h0.6c0.7-1.1,1.6-2,2.9-2.7 c1.3-0.6,2.7-0.9,4.3-0.9c2.8,0,4.9,0.7,6.3,2.1c1.4,1.4,2.1,3.7,2.1,6.9v16h-6.7V60.4c0-1.8-0.3-3.1-0.9-4 c-0.6-0.9-1.5-1.3-2.8-1.3c-1.6,0-2.9,0.6-3.7,1.8c-0.8,1.2-1.2,3-1.2,5.6V74.7z"
}), React.createElement("path", {
  d: "M192.4,43.8c0-2.2,1.2-3.3,3.6-3.3c2.4,0,3.6,1.1,3.6,3.3c0,1-0.3,1.8-0.9,2.4c-0.6,0.6-1.5,0.9-2.7,0.9 C193.7,47.1,192.4,46,192.4,43.8z M199.4,74.7h-6.7V50.2h6.7V74.7z"
}), React.createElement("path", {
  d: "M219.1,69.8c1.2,0,2.6-0.3,4.2-0.8v5c-1.7,0.7-3.7,1.1-6.2,1.1c-2.7,0-4.6-0.7-5.9-2c-1.2-1.4-1.8-3.4-1.8-6.1V55.2h-3.2 v-2.8l3.7-2.2l1.9-5.2h4.3v5.2h6.9v5h-6.9v11.8c0,1,0.3,1.7,0.8,2.1C217.5,69.6,218.2,69.8,219.1,69.8z"
}), React.createElement("path", {
  d: "M241.6,75.2c-4,0-7-1.1-9.3-3.3c-2.2-2.2-3.3-5.3-3.3-9.3c0-4.1,1-7.3,3.1-9.5s4.9-3.4,8.5-3.4c3.5,0,6.2,1,8.1,3 c1.9,2,2.9,4.7,2.9,8.2v3.3h-15.8c0.1,1.9,0.6,3.4,1.7,4.5c1.1,1.1,2.5,1.6,4.4,1.6c1.5,0,2.9-0.2,4.2-0.5 c1.3-0.3,2.7-0.8,4.1-1.5v5.2c-1.2,0.6-2.4,1-3.8,1.3S243.5,75.2,241.6,75.2z M240.7,54.5c-1.4,0-2.5,0.5-3.3,1.4 c-0.8,0.9-1.3,2.2-1.4,3.8h9.4c0-1.7-0.5-2.9-1.3-3.8C243.2,54.9,242.1,54.5,240.7,54.5z"
})), React.createElement("path", {
  d: "M186.7,34.5l-2.5-2.5c3.1-3,7.3-4.9,11.9-4.9c4.7,0,8.9,1.9,12,4.9l-2.5,2.5c-2.4-2.4-5.8-3.8-9.5-3.8 C192.5,30.7,189.2,32.2,186.7,34.5z M196.2,37.4c1.8,0,3.5,0.7,4.7,1.9l2.5-2.5c-1.8-1.8-4.4-3-7.2-3c-2.8,0-5.3,1.1-7.2,2.9 l2.5,2.5C192.7,38.1,194.4,37.4,196.2,37.4z"
}), React.createElement("ellipse", {
  cx: 262,
  cy: 70.7,
  rx: 5.1,
  ry: 5.2
}));

var SvgTransmiteLive = function SvgTransmiteLive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "transmite.live",
    x: "0px",
    y: "0px",
    viewBox: "0 0 387 113",
    style: {
      enableBackground: "new 0 0 387 113"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTransmiteLive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transmite_live.77a6a1bf.svg";
export { ForwardRef as ReactComponent };